import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpStateService } from '../services/http-state.service';

@Injectable()
export class HttpStateInterceptor implements HttpInterceptor {
  private activeRequestKeys = new Set<string>();

  constructor(private httpState: HttpStateService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isMutating = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(request.method);

    if (isMutating) {
      // Generate a unique key for this request
      const bodyStr = request.body ? JSON.stringify(request.body) : '';
      const requestKey = `${request.method}:${request.urlWithParams}:${bodyStr}`;

      // If the exact same request is already running, block it!
      if (this.activeRequestKeys.has(requestKey)) {
        console.warn('Blocked duplicate HTTP request:', request.url);
        return EMPTY;
      }

      this.activeRequestKeys.add(requestKey);
      this.httpState.startRequest();

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequestKeys.delete(requestKey);
          this.httpState.endRequest();
        })
      );
    }

    return next.handle(request);
  }
}
